import styles from "./StatisticsDialogKeyValueItem.module.scss";
import React from "react";

interface IStatisticsDialogKeyValueItemProps {
  name: string;
  value: string | number | React.ReactNode;
}

export const StatisticsDialogKeyValueItem = ({
  name,
  value,
}: IStatisticsDialogKeyValueItemProps) => {
  return (
    <div className={styles.info_group}>
      <p className={styles.info_group_key}>{name}</p>
      <p className={styles.info_group_value}>{value}</p>
    </div>
  );
};
